export const friends = {
  Friend: "Friend",
  FriendList: "Friend List",
  AddFriend: "Add Friend",
  AddFriendDesc: "Add a friend to list.",
  AddFriendRequest: "Would you like to add {name} as a friend?",
  RemoveFriend: "Remove Friend",
  RemoveFriendDesc: "Remove a friend from your friends list.",
  AcceptFriend: "Accept Friend",
  AcceptFriendDesc: "Accept a friend request.",
  CancelFriend: "Cancel Friend",
  CancelFriendDesc: "Cancel a friend request.",
  ManageFriend: "Manage Friend",
  SearchUser: "Search User",
  SearchUserPlaceHolder: "Search by name or email",
  SentRequests: "Sent Requests",
  ReceivedRequests: "Received Requests",
  SendWhisper: "Send Whisper",
  SendWhisperDesc:
    "A whisper is a message that is delivered directly to the recipient without being stored on the server.",
  LastSeen: "Last Seen",
} as const;
